import styled from 'styled-components';
import { colors } from '@/styles/GlobalStyle';

export const Container = styled.section`
  width: 100%;
  max-width: 1024px;

  display: flex;
  flex-direction: column;
  align-items: center;

  margin-top: 63px;

  a {
    width: 100%;
    height: 56px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
    max-width: 262px;
    gap: 10px;
    background: ${colors.purple400};
    border-radius: 12px;
    cursor: pointer;
    transition: 0.1s linear;
    margin-top: 38px;

    @media (max-width: 650px) {
      max-width: initial;
    }

    :hover {
      background: #5000a2;
    }
  }

  @media (max-width: 650px) {
    margin-top: 32px;
  }
`;

export const Top = styled.div`
  width: 100%;

  display: flex;
  flex-direction: column;
  align-items: center;

  text-align: center;

  h1 {
    font-size: 40px;
    line-height: 48px;
    font-weight: bold;
    margin-top: 30px;
    max-width: 412px;
  }

  p {
    font-size: 18px;
    margin-top: 20px;
    line-height: 28px;
    max-width: 650px;
  }

  @media (max-width: 650px) {
    h1 {
      font-size: 32px;
      line-height: 40px;
    }

    p {
      font-size: 16px;
      line-height: 24px;
    }

    a {
      display: none;
    }
  }
`;

export const Bottom = styled.div`
  width: 100%;
  max-width: 688px;

  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  row-gap: 50px;
  column-gap: 24px;

  margin-top: 90px;

  a {
    display: none;
  }

  @media (max-width: 650px) {
    margin-top: 44px;

    a {
      display: flex;
    }
  }

  @media (max-width: 475px) {
    justify-content: space-around;
  }
`;

export const Aplicativo = styled.div<{ exclusive?: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  z-index: 1;

  img {
    width: 100%;
  }

  .shadow {
    position: relative;
    display: flex;
    z-index: 0;
    width: 100%;

    ::after {
      content: '';
      left: 0;
      top: -1px;
      width: 100%;
      height: 100%;
      position: absolute;
      border-radius: 45px;
      z-index: 0;
    }
  }

  .rastreamento-encomenda {
    ::after {
      box-shadow: 0px 7px 15px ${colors.yellow}80;
    }
  }

  .coleta {
    ::after {
      box-shadow: 0px 7px 15px ${colors.blue}80;
    }
  }

  .rastreamento-coleta {
    ::after {
      box-shadow: 0px 7px 15px #ff3a3880;
    }
  }

  .segunda-via-boleto {
    ::after {
      box-shadow: 0px 7px 15px #8a26d780;
    }
  }

  .cotacao {
    ::after {
      box-shadow: 0px 7px 15px ${colors.green}80;
    }
  }

  .busca-filiais {
    ::after {
      box-shadow: 0px 7px 15px ${colors.red}80;
    }
  }

  span {
    font-size: 16px;
    line-height: 20px;
    font-weight: 600;
    display: inline-block;
    margin-top: 24px;
    max-width: 134px;
  }

  ::after {
    content: 'API exclusiva Hyerdev';
    display: ${({ exclusive }) => (exclusive ? 'block' : 'none')};
    padding: 2px 10px;
    border-radius: 6px;

    transition: background 0.15s linear, color 0.15s linear;
    background: ${({ theme }) => theme.aplicativos.heroSection.api.background};
    color: ${({ theme }) => theme.aplicativos.heroSection.api.text};
    font-size: 10px;
    line-height: 20px;
    font-weight: 500;
    margin-top: 5px;
  }

  @media (max-width: 650px) {
    max-width: 150px;
  }

  @media (max-width: 570px) {
    max-width: 126px;
  }

  @media (max-width: 475px) {
    max-width: 130px;
  }

  @media (max-width: 350px) {
    max-width: 126px;
  }
`;
